import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="App-footer">
      <p>&copy; {new Date().getFullYear()} What The Phish Reports. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
